import React from 'react';
import { handleView } from '../handle_view';
import { FreeMobileFittingLightBoxStore } from '../../_flux/stores/free_mobile_fitting_light_box';
import { LightBox } from '../../_flux/components/free_mobile_fitting_light_box/light_box';
import { hide } from '../../_flux/actions/free_mobile_fitting_light_box_actions';

const stores = {
    lightBox: FreeMobileFittingLightBoxStore,
};

const render = ({ lightBox }, options) => (
    <LightBox
        visible={lightBox.visible}
        onClose={hide}
        staticUrl={TYROOLA.globals.staticImagesUrl}
        baseUrl={options.baseUrl}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
